import React from 'react';
import { StatusBar } from 'expo-status-bar';
import { Platform } from 'react-native';
import WebNavigator from './src/navigation/WebNavigator';
import { AuthProvider } from './src/contexts/AuthContext';
import { GameProvider } from './src/contexts/GameContext';

// Conditionally import AppNavigator only for non-web platforms
let AppNavigator: any = null;
if (Platform.OS !== 'web') {
  AppNavigator = require('./src/navigation/AppNavigator').default;
}

export default function App() {
  if (Platform.OS === 'web') {
    return (
      <AuthProvider>
        <GameProvider>
          <WebNavigator />
          <StatusBar style="light" backgroundColor="#8B4513" />
        </GameProvider>
      </AuthProvider>
    );
  }

  return (
    <AuthProvider>
      <GameProvider>
        <AppNavigator />
        <StatusBar style="light" backgroundColor="#8B4513" />
      </GameProvider>
    </AuthProvider>
  );
}
